import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { LegalFooter } from './LegalLinks';
import PrivacyContent from './PrivacyContent';
import TermsContent from './TermsContent';
import RefundsContent from './RefundsContent';

const PAGES = {
  privacy: { title: 'Privacy notice', Content: PrivacyContent },
  terms: { title: 'Terms of use', Content: TermsContent },
  refunds: { title: 'Refunds', Content: RefundsContent },
};

export const LAST_UPDATED = '3 November 2026';

export default function LegalPage({ page }) {
  const { title, Content } = PAGES[page];

  useEffect(() => {
    const previous = document.title;
    document.title = `${title} | Coach Rands`;
    window.scrollTo(0, 0);
    return () => { document.title = previous; };
  }, [title]);

  return (
    <div className="min-h-screen bg-mono-base flex flex-col" data-testid={`legal-page-${page}`}>
      <header className="border-b border-mono-line">
        <div className="max-w-5xl mx-auto px-4 md:px-8 h-14 flex items-center justify-between">
          <Link to="/free" className="text-white font-heading text-xs md:text-sm font-bold uppercase tracking-[0.25em]" data-testid="legal-home-link">
            Coach Rands Method
          </Link>
        </div>
      </header>
      <main className="flex-1 max-w-3xl w-full mx-auto px-4 md:px-8 py-10 md:py-14">
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight text-white leading-none mb-3" data-testid="legal-page-title">
          {title}
        </h1>
        <p className="text-mono-mute font-body text-sm mb-10">Last updated: {LAST_UPDATED}</p>
        <Content />
      </main>
      <LegalFooter />
    </div>
  );
}
